import type { SignerLookupResponse } from '@/shared/breb/keys/types/brebSignerLookup.type';
import { maskFullName } from '@/shared/common/utils/maskFullName.util';

/**
 * Resuelve el nombre del titular de una llave Bre-B, con respaldo en el nombre
 * compuesto cuando `name` no trae contenido.
 * @param signer - Firmante Bre-B resuelto por el lookup.
 * @returns Nombre del titular, o cadena vacía cuando el backend no envió ninguno.
 */
export function resolveSignerDisplayName(signer: SignerLookupResponse): string {
  return (
    signer.name || `${signer.firstName ?? ''} ${signer.lastName ?? ''}`
  ).trim();
}

/**
 * Resuelve el nombre del titular enmascarado para mostrarlo al remitente.
 * @param signer - Firmante Bre-B resuelto por el lookup.
 * @returns Nombre del titular enmascarado, o cadena vacía cuando no hay nombre.
 */
export function resolveMaskedSignerName(signer: SignerLookupResponse): string {
  return maskFullName(resolveSignerDisplayName(signer));
}
